<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TableAna',
})
</script>
<template>
  <div class="ant-table-ana">
    <span v-for="item in map">
      <b>{{ item[0] }}：</b>{{ data?.[item[1]] ?? '-' }} {{ item[2] }}
    </span>
  </div>
</template>

<script lang="ts" setup name="TableAna">
defineProps<{
  data?: Record<string, any>
  map?: string[][]
}>()
</script>
